/**
 * Портал в конец документа. В проекте нет типов для react-dom, а ставить
 * пакет ради одной функции незачем — типизируем границу здесь.
 */
import React from 'react'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore в проекте не установлены типы для react-dom
import { createPortal as reactCreatePortal } from 'react-dom'

export const createPortal = reactCreatePortal as (
  children: React.ReactNode,
  container: Element,
) => React.ReactElement
